import { arrayMove } from '@dnd-kit/sortable'

import Content from './Content'
import Item from './Item'
import SortProvider from './SortProvider'

const SortableList = (props: React.ComponentProps<typeof Content>) => (
  <SortProvider>
    <Content {...props} />
  </SortProvider>
)

SortableList.Item = Item
SortableList.arrayMove = arrayMove

export default SortableList
